import TextCell from 'components/TextCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function KeyCell({ rowData: { key } }: CellProps) {
  return <TextCell text={key} />;
}
